import { createModify } from './base';
import { create as createPrism } from './prism';
export { key, prop, index, withDefault, replace, find } from './json';
/**
 * Create a lens.
 *
 * @export
 * @template O type of the source
 * @template P type of the destination
 * @param getter a getter function
 * @param setter a setter function
 * @returns a lens that operates by given getter and setter
 */
export function create(getter, setter) {
    return {
        get: getter,
        set: setter,
        modify: createModify(getter, setter),
        compose(next) {
            return create((s) => next.get(getter(s)), (v, s) => setter(next.set(v, getter(s)), s));
        }
    };
}
export function compose(...lenses) {
    if (lenses.length === 0) {
        throw new TypeError('Can not compose zero lenses. You probably want `Lens.identity`.');
    }
    else if (lenses.length === 1) {
        return lenses[0];
    }
    else {
        let r = lenses[0];
        lenses.slice(1).forEach(l => {
            r = r.compose(l);
        });
        return r;
    }
}
const _identity = create(x => x, (x, _) => x);
/**
 * The identity lens – a lens that reads and writes the object itself.
 */
export function identity() {
    return _identity;
}
const _nothing = createPrism(_ => undefined, (_, o) => o);
/**
 * A lens that always returns `undefined` on `get` and does no change on `set`.
 */
export function nothing() {
    return _nothing;
}
//# sourceMappingURL=lens.js.map